import '@babel/polyfill'
import $ from "jquery"

const selectors = {
    modal: "[data-modal='default']",
    modalShort: "[data-modal='short']",
    modalClose: '[data-modal-close]',
    modalOpen: '[data-modal-open]',
    modalLink: '[data-modal-link]',
    modalTab: '[data-modal-tab]',
    isActive: '-active',
    formValidate: '[required]'
  }

export default () => {
    const modal = document.querySelector(selectors.modal)
    const modalShort = document.querySelector(selectors.modalShort)

    if (!modal && !modalShort) {
        return
    }
  
    const modalClose = document.querySelectorAll(selectors.modalClose)
    const modalLinks = modal.querySelectorAll(selectors.modalLink)

    const modalOpen = document.querySelectorAll(selectors.modalOpen)
    const modalTabs = document.querySelectorAll(selectors.modalTab)
    let type = null
    const requiredCheckboxes = document.querySelectorAll(".js-required-checkboxes")

    if(requiredCheckboxes){
        requiredCheckboxes.forEach(check => {
            check.addEventListener('change', (event) => {
                const reqCheckIs = checkRequiredCheckboxes()
                enableSubmitButton(reqCheckIs)
            })
        })

        
    }

    const checkRequiredCheckboxes = function() {
        var reqBoxes = []
        requiredCheckboxes.forEach(cb => {
            reqBoxes.push(cb.checked)
        })
        return reqBoxes.every(checkIfTrue)
    }

    const checkIfTrue = function(value){
        return value
    }

    const enableSubmitButton = function (enable) {
        const submitButtons = document.querySelectorAll(".js-submit-button")
        submitButtons.forEach(btn => {
            if(enable)
                btn.classList.remove("-disabled")
            else
                btn.classList.add("-disabled")
        })
    }

    const checkboxesTrue = function () {
        requiredCheckboxes.forEach(check =>{
            check.checked = true
        })
    }

    const closeModal = function () {
        modal.classList.remove(selectors.isActive)
        modalShort.classList.remove(selectors.isActive)
        Array.from(modalLinks).forEach(link => link.classList.remove(selectors.isActive))
        Array.from(modalTabs).forEach(tab => tab.classList.remove(selectors.isActive))

        const meta = modal.querySelector('[data-event-meta]')
        const metaShort = modalShort.querySelector('[data-event-meta]')
        const privateTab = modal.querySelector('[data-event-private]')
        const companyTab = modal.querySelector('[data-event-company]')

        const data = document.querySelector('[data-event-modal="' + type + '"]')

        if (data) {
            if(meta){
                data.appendChild(meta)
            }
            if(metaShort){
                data.appendChild(metaShort)
            }
        }
    }

    const selectTab = function (index) {
        Array.from(modalLinks).forEach(link => link.classList.remove(selectors.isActive))
        modalLinks[index].classList.add(selectors.isActive)
        Array.from(modalTabs).forEach(tab => tab.classList.remove(selectors.isActive))
        modalTabs[index].classList.add(selectors.isActive)
    }

    Array.from(modalClose).map(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            closeModal()
        })
    })
    /*modalClose.addEventListener('click', (e) => {
        e.preventDefault()
        closeModal()
    })*/

    Array.from(modalOpen).map(el => {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            //type = el.dataset.modalOpen
            type = e.target.dataset.modalOpen
            const modalType = e.target.dataset.modalType
            const data = document.querySelector('[data-event-modal="' + type + '"]')

            if (data) {
                const meta = data.querySelector('[data-event-meta]')
                const privateTab = data.querySelector('[data-event-private]')
                const companyTab = data.querySelector('[data-event-company]')

                if(modalType == "short"){
                    modalShort.querySelector('[data-modal-meta]').innerHTML = ''
                    modalShort.querySelector('[data-modal-meta]').appendChild(meta)
                    modalShort.classList.add(selectors.isActive)
                } else if (modalType == "default") {
                    modal.querySelector('[data-modal-meta]').innerHTML = ''
                    modal.querySelector('[data-modal-meta]').appendChild(meta)
                    /*const modaltabkes = modal.querySelectorAll('[data-modal-tab]')
                    modaltabkes[0].innerHTML = ''
                    modaltabkes[0].appendChild(privateTab)
                    modaltabkes[1].innerHTML = ''
                    modaltabkes[1].appendChild(companyTab)*/
                    modal.classList.add(selectors.isActive)
                }
            }
        })
    })

    Array.from(modalLinks).map((link, index) => {
        link.addEventListener('click', e => {
            e.preventDefault()
            checkboxesTrue()
            enableSubmitButton(true)
            selectTab(index)
        })
    })

    const businessButtons =  document.querySelectorAll(".c-business-form__button")
    businessButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            const businessForm = document.querySelector('[data-event-company]')

            if(!validateForm(businessForm)){
                $(".c-registerModal__message").text("Please fill in all required fields. (*)")
                return
            }

            enableSubmitButton(false)  
            const bemailForm = document.querySelector("#bemail").value
            $("#bmc_embed_signup").children().unwrap().wrapAll("<form action='https://swiss.us19.list-manage.com/subscribe/post?u=3ac1f77f978ce8ea864355c23&amp;id=fd6d7fc0fb' method='post' id='bmc-embedded-subscribe-form' name='bmc-embedded-subscribe-form' class='validate' target='_blank' novalidate></form>")
            //const bmailChimpBtn = document.querySelector("#bmc-embedded-subscribe-form")
            subscribeMailChimp(bemailForm, "#bmc_embed_signup")
            const bmailchimpFormData = $("#bmc-embedded-subscribe-form").serialize()
            $.ajax({
                type: "POST",
                url: "https://swiss.us19.list-manage.com/subscribe/post?u=3ac1f77f978ce8ea864355c23&amp;id=fd6d7fc0fb",
                data: bmailchimpFormData,
                crossDomain: true,
                dataType: "jsonp",
                cache: false,
                success: function(result){
                }
            })
            const formData = $("#c-trainingEvent__form").serialize()
            $.ajax({
                type: "POST",
                url: "wp-content/themes/training-coaching-square/inc/coachviewBusiness.php",
                data: formData,
                cache: false,
                success: function(result){
                    //alert(result);
                    $(".c-registerModal__links").addClass("hidden")
                    $(".c-registerModal__tabs").addClass("hidden")
                    $(".c-registerModal__message").text("Succesvol ingestuurd")
                }
            });
        })
    })

    const privateButtons =  document.querySelectorAll(".c-private-form__button")
    privateButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            const privateForm = document.querySelector('[data-event-private]')

            if(!validateForm(privateForm)){
                $(".c-registerModal__message").text("Please fill in all required fields. (*)")
                return
            }

            enableSubmitButton(false)  
            const emailForm = document.querySelector("#email").value
            $("#pmc_embed_signup").children().unwrap().wrapAll("<form action='https://swiss.us19.list-manage.com/subscribe/post?u=3ac1f77f978ce8ea864355c23&amp;id=fd6d7fc0fb' method='post' id='mc-embedded-subscribe-form' name='mc-embedded-subscribe-form' class='validate' target='_blank' novalidate></form>")
            subscribeMailChimp(emailForm, "#pmc_embed_signup")
            //const newForm = document.getElementById("mc-embedded-subscribe-form")
            const mailchimpFormData = $("#mc-embedded-subscribe-form").serialize()
            $.ajax({
                type: "POST",
                url: "https://swiss.us19.list-manage.com/subscribe/post?u=3ac1f77f978ce8ea864355c23&amp;id=fd6d7fc0fb",
                data: mailchimpFormData,
                crossDomain: true,
                dataType: "jsonp",
                cache: false,
                success: function(result){
                    //console.log(result)
                }
            })
            const formData = $("#c-trainingEvent__form").serialize()
            //console.log(formData)
            $.ajax({
                type: "POST",
                url: "wp-content/themes/training-coaching-square/inc/coachviewPrivate.php",
                data: formData,
                cache: false,
                success: function(result){
                    //alert(result);
                    $(".c-registerModal__links").addClass("hidden")
                    $(".c-registerModal__tabs").addClass("hidden")
                    $(".c-registerModal__message").text("Succesvol ingestuurd")
                }
            })
        })
    })

    const shortButtons =  document.querySelectorAll(".c-short-form__button")
    shortButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
            const shortForm = document.getElementById('c-trainingShort__form')

            if(!validateForm(shortForm)){
                $(".c-registerModal__message").text("Please fill in all required fields. (*)")
                return
            }

            enableSubmitButton(false)        
            const formData = $("#c-trainingShort__form").serialize()
            $.ajax({
                type: "POST",
                url: "wp-content/themes/training-coaching-square/inc/coachviewShort.php",
                data: formData,
                cache: false,
                success: function(result){
                    $(".c-registerModal__links").addClass("hidden")
                    $(".c-registerModal__tabs").addClass("hidden")
                    $(".c-registerModal__message").text("Succesvol ingestuurd")
                }
            })
        })
    })

    const subscribeMailChimp = (formEmail, mcBtn) => {
        const mcEmail = document.querySelectorAll(".js-mc-email")
        mcEmail.forEach(mceField => {
            mceField.value = formEmail
        })
        //console.log(mcEmail)
        //$(mcBtn).children().unwrap().wrapAll("<form action='https://swiss.us19.list-manage.com/subscribe/post?u=3ac1f77f978ce8ea864355c23&amp;id=fd6d7fc0fb' method='post' id='mc-embedded-subscribe-form' name='mc-embedded-subscribe-form' class='validate' target='_blank' novalidate></form>")
        
        //const newForm = document.getElementById("mc-embedded-subscribe-form")

        //mcBtn.action = "https://swiss.us19.list-manage.com/subscribe/post?u=3ac1f77f978ce8ea864355c23&amp;id=fd6d7fc0fb"
        //newForm.submit()
        //mcBtn.click()
    }

    const validateForm = (form) => {
        var valid = true
        const requiredFields = form.querySelectorAll(selectors.formValidate)

        requiredFields.forEach((field) => {
            if(!field.value){
                valid = false
            }
        })

        return valid
    }
}
